export { StorageLocationEnum as StorageLocation } from "@bitwarden/storage-core";
